<template>
	<main>
		<section class="vx-row" v-if="data.length > 0">
			<div 
				class="vx-col w-full md:w-1/2 lg:w-1/3 mb-6"
				v-for="(campaign, i) in data"
				:key="i"
			>
			<vx-card class="p-0">
				<router-link :to="`/campaign/view/${ campaign.slug + '-' + toBase64(campaign.id + '') }`">
				<div class="vx-row">
					<div slot="no-body" 
						class="md:mr-0 md:mb-4 vx-col w-1/3 md:w-full h-56 md:h-64 card-img-top"
						:style="{ backgroundImage: `url('${imageLink(campaign)}')`, backgroundSize: 'cover' }" 
					>
					</div>
					<div class="mb-6 vx-col w-2/3 md:w-full">
						<p class="mb-2 md:mb-4" style="height: 3rem;overflow: auto;"><strong>{{campaign.name}}</strong></p>
						<vs-progress class="mb-2 md:mb-4" :percent="donationPercent(campaign)"></vs-progress>
						<div class="flex justify-between items-center">
							<div>
								<small class="block">Terkumpul</small>
								<strong><span class="text-danger">
									Rp {{ formatRupiah(campaign.donasi_terkumpul) }}
								</span></strong>
							</div>
							<div>
								<small class="block">Sisa hari</small>
								<strong>{{ remainDay(campaign) }}</strong>
							</div>
						</div>
					</div>
				</div>
				</router-link>
			</vx-card>	
		</div>	
		</section>
		<div v-else class="text-center my-12">
			<h4 class="text-grey">Belum ada donasi yang dibuat.</h4>
		</div>
	</main>
	
</template>
<script >
export default {
  props: ['data'],
  data: () => ({
	  isZxCare: false
  }),
  methods: {
    imageLink (campaign) {
      if (campaign.file !== null) {
        return `${process.env.VUE_APP_STORAGE  }/${  campaign.file}`
      }
				
      return 'https://imgix.kitabisa.com/3f39c017-d125-46b3-9520-657ba793d409.jpg?ar=16:9&w=664&auto=format,compress&fm=pjpg&cs=tinysrgb&fit=scale'
    },
    donationPercent (campaign) {
      return Math.ceil((parseInt(campaign.donasi_terkumpul) / parseInt(campaign.donasi)) * 100)
    },
    remainDay (campaign) {
      const mulai = new Date(campaign.mulai),
        selesai = new Date(campaign.selesai),
        timeDifferent = selesai.getTime() - mulai.getTime(),
        dayMilsec = 1000 * 60 * 60 * 24

      return timeDifferent / dayMilsec
    }
  },
  created() {
	  if(this.$router.currentRoute.name === 'zxcare') {
		  this.isZxCare = true
	  }
  }
}
</script>